import { useEffect, useState } from "react";
import { Button, Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { COLOR } from "../../../utils/colors";
import { defaultHeaderStyle } from "../../robots/components/v2/_style";
import { MapType } from "../../../hooks/map.type";
import { useListConfigRobotMap } from "../../../hooks/config-page";
import { useNavigate } from "react-router-dom";
import { useUnbindMapMutation } from "../../../hooks/config-page/bind-map";
import { useQueryState } from "nuqs";



const columns = ['Robot Map Name', 'Level', 'Preview', 'Action']

export default function ListRobotMapTable({
  selectable = false,
  onSelectedChange,
  search,
  showForBind
}: {
  selectable?: boolean,
  onSelectedChange?: (selecteds: MapType[]) => void,
  search?: string,
  showForBind?: boolean
  onResetSearch?: () => void
}) {
  const [building_uuid] = useQueryState('building_uuid', { clearOnDefault: true })
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [selectedRobotMaps, setSelectedRobotMaps] = useState<MapType[]>([])
  const navigate = useNavigate()

  const { data: dataRobotMaps, refetch, isLoading } = useListConfigRobotMap({
    page: page,
    page_size: rowsPerPage,
    show_bind: showForBind,
    search: search || '',
    building_uuid: building_uuid || '',
  })

  useEffect(() => {
    refetch()
  }, [search, page, rowsPerPage])

  const robotMaps = dataRobotMaps?.data || []
  const itemCount = dataRobotMaps?.count || 1

  const handleChangePage = (newPage: number) => {
    setPage(newPage + 1)
  }

  const handleChangeRowsPerPage = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage)
    setPage(1)
  }

  const isSelected = (robotMap: MapType) => {
    return selectedRobotMaps.find((r) => r.map_uuid === robotMap.map_uuid) !== undefined
  }

  const handleSelectRobot = (robot: MapType) => {
    if (isSelected(robot)) {
      const updatedSelectedRobots = selectedRobotMaps.filter((r) => r.map_uuid !== robot.map_uuid)
      setSelectedRobotMaps(updatedSelectedRobots)
      onSelectedChange?.(updatedSelectedRobots)
      return
    }
    const newSelectedRobots = [...selectedRobotMaps, robot]
    setSelectedRobotMaps(newSelectedRobots)
    onSelectedChange?.(newSelectedRobots)
  }

  const handleEdit = (robotMap: MapType) => {
    window.location.href = '/config/robot-maps/edit/' + robotMap.map_uuid
  }

  return (
    <Paper elevation={2} sx={{ display: 'flex', flexDirection: 'column', maxHeight: showForBind ? "58vh" : "67vh", borderRadius: "10px", border: "1px solid #E0E0E0", m: '20px auto' }}>
      <TableContainer sx={{ backgroundColor: "#F5F5F5", alignItems: "center", overflowX: "auto" }}>
        <Table stickyHeader>
          <TableHead sx={{ width: "100%", margin: "auto" }}>
            <TableRow sx={{ width: "100%", margin: "auto" }}>
              {selectable && (
                <TableCell width={80} align="center" sx={{ ...defaultHeaderStyle, textTransform: 'capitalize' }}>
                </TableCell>
              )}
              {columns.map((column, index) => (
                <TableCell key={index} align="center" sx={{ ...defaultHeaderStyle, textTransform: 'capitalize' }}>
                  {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {robotMaps.map((robotMap, index) => (
              <TableRow key={index} sx={{ cursor: 'pointer', '&:hover': { backgroundColor: COLOR.gray[100] } }} onClick={() => handleSelectRobot(robotMap)}>
                {selectable && (
                  <TableCell align="center" sx={{ ...defaultHeaderStyle, width: '80px' }}>
                    <Checkbox
                      checked={isSelected(robotMap)}
                      onChange={() => handleSelectRobot(robotMap)}
                    />
                  </TableCell>
                )}
                <TableCell align="center" sx={{ ...defaultHeaderStyle }}>{robotMap.map_name_display}</TableCell>
                <TableCell align="center" sx={{ ...defaultHeaderStyle }}>{robotMap.map_level}</TableCell>
                <TableCell align="center" sx={{ ...defaultHeaderStyle }}>
                  <img src={robotMap.map_image} alt={robotMap.map_name} style={{ width: '250px', height: 'auto' }} />
                </TableCell>
                <TableCell align="center" sx={{ ...defaultHeaderStyle }}>
                  <Button onClick={() => handleEdit(robotMap)}>
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            ))}
            {robotMaps.length === 0 && !isLoading && (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ color: COLOR.gray[500] }}>
                  No Selected Robot Maps data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={itemCount}
        rowsPerPage={rowsPerPage}
        page={page - 1}
        onPageChange={(e, num) => handleChangePage(num)}
        onRowsPerPageChange={(e) => handleChangeRowsPerPage(parseInt(e.target.value || '10'))}
        sx={{ flexShrink: 0, boxShadow: "none" }} // Prevent pagination from shrinking
      />
    </Paper>
  )

}